import { appState } from '../../../../../interfaces/common';
// Cosmos
import { CardHeader, Flex, Image, MenuButton, Text } from '@pega/cosmos-react-core';
// React
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import styled, { css } from 'styled-components';

import useLocalTranslation from '../../../../../hooks/useLocalTranslation';

const FullWidthFlex = styled.div(
  () =>
    css`
      width: 100%;
    `,
);

const TitleText = styled.h2(
  ({ theme }) =>
    css`
      color: ${theme.base.colors.white};
      font-weight: 650;
      padding-top: 0.4rem;
    `,
);

interface ChatHeaderProps {
  selectedThemeColor?: any;
  selectedHeaderTextColor?: any;
  enableMultiExperienceWidget?: boolean;
  headerHeightHandler: Function;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
  selectedThemeColor,
  selectedHeaderTextColor,
  enableMultiExperienceWidget,
  headerHeightHandler,
}) => {
  const {
    chatInfo: { logo, displayLogo, widgetTitles },
  } = useSelector((state: appState) => {
    return {
      chatInfo: state.chatInfo,
    };
  });
  const translate = useLocalTranslation();

  const headerStyle = {
    backgroundColor: selectedThemeColor,
    borderTopLeftRadius: enableMultiExperienceWidget ? '0rem' : '0.4rem',
    borderTopRightRadius: '0.4rem',
  };

  const headerTextStyle = {
    fontSize: 15,
    color: selectedHeaderTextColor,
  };

  const WidgetTitle = () => (
    <Flex
      container={{
        direction: 'column',
        alignItems: 'center',
      }}
    >
      <Text as={TitleText} style={headerTextStyle}>
        {widgetTitles ? widgetTitles[Object.keys(widgetTitles)[0]] : ''}
      </Text>
    </Flex>
  );

  const chatHeaderRef = useRef<any>();

  useEffect(() => {
    const height = chatHeaderRef?.current?.clientHeight;
    headerHeightHandler(height);
  }, [headerHeightHandler, chatHeaderRef]);

  return (
    <CardHeader style={headerStyle} ref={chatHeaderRef}>
      <Flex container={{ direction: 'row', itemGap: 1, alignItems: 'start' }} as={FullWidthFlex}>
        {!enableMultiExperienceWidget && displayLogo && logo && (
          <Image
            src={logo}
            alt="widget-logo"
            style={{
              height: 32,
              width: 32,
              borderRadius: '50%',
            }}
          />
        )}
        <Flex as={FullWidthFlex}>
          <Flex
            container={{
              direction: 'row',
              itemGap: 1,
              alignItems: 'center',
              justify: 'between',
            }}
            item={{ grow: 1 }}
          >
            <WidgetTitle />
          </Flex>
        </Flex>
        <MenuButton icon="more" iconOnly variant="simple" text={translate('more_option')} style={{ color: '#fff' }} />
      </Flex>
    </CardHeader>
  );
};

export default ChatHeader;
